import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SettingService } from '../../../../common/services/Setting.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-setting-sale',
  templateUrl: 'setting-sale.templete.html',
  styleUrls: ['./business.css'],
  providers: [SettingService],
})
export class SettingSaleComponent implements OnInit {
  public activeConfig: Number = 0;
  public activeBussiness: Number = 0;
  public activeAgency: Number = 0;
  public dataBussiness = {
    pp: false,
    sms: false,
    loyalty: false
  };
  public dataAgency = {
    pp: false,
    sms: false,
    loyalty: false
  };

  constructor(
    private _fb: FormBuilder,
    private settingService: SettingService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.getList();
  }

  getList() {
    this.dataBussiness = {
      pp: false,
      sms: false,
      loyalty: false
    };
    this.dataAgency = {
      pp: false,
      sms: false,
      loyalty: false
    };
    let resultBussiness;
    let resultAgency;
    this.settingService.getDetailSettingConfig().subscribe((res: any) => {
      console.log('res', res)
      if (res.code == 1 && res.data) {
        res.data.map((item) => {
          if (item.settingType == 1) {
            resultBussiness = item.listType
            resultBussiness.map((val) => {
              if (val == 1) {
                this.dataBussiness.pp = true;
              } else if (val == 2) {
                this.dataBussiness.loyalty = true
              } else if (val == 3) {
                this.dataBussiness.sms = true
              }
            })
          }
          if (item.settingType == 2) {
            resultAgency = item.listType
            resultAgency.map((val) => {
              if (val == 1) {
                this.dataAgency.pp = true;
              }
              if (val == 2) {
                this.dataAgency.loyalty = true
              }
              if (val == 3) {
                this.dataAgency.sms = true
              }
            })
          }
        })
      }
      console.log('resultBussiness', resultBussiness)
    }, (err: any) => {
      this.toastr.warning(this.translate.instant('CO_LOI_XAY_RA'), this.translate.instant('THAT_BAI'), {
        timeOut: 4000,
        positionClass: 'toast-top-right'
      })
    })
  }

  updateBusinness(params: any) {
    this.activeConfig = 1;
    if (params == 1) {
      this.activeBussiness = 1;
    } else {
      this.activeAgency = 2;
    }
  }

  closeUpdateAgency(event) {
    if (event.isBack == true) {
      this.activeBussiness = 0;
      this.activeAgency = 0;
      this.activeConfig = 0;
      this.getList();
    }
  }

  closeUpdateBusiness(event) {
    if (event.isBack == true) {
      this.activeBussiness = 0;
      this.activeAgency = 0;
      this.activeConfig = 0;
      this.getList();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-sale.component.ts